// noinspection JSValidateTypes

import {Basic} from "./Basic";
import {History} from "./History";
import {Load} from "./Load";
import {Modal} from "./Modal";

export class Delivery
{
    constructor()
    {
        this.limits = {};

        this.delivery = localStorage.getItem("delivery") ? JSON.parse(localStorage.getItem("delivery")) : {};
        this.pickup = sessionStorage.getItem("pickup") ? JSON.parse(sessionStorage.getItem("pickup")) : {};
        this.update_customAddressForm();
        this.get_limits();
    }

    process(action, noMessage)
    {
        let message;
        if(noMessage !== true)
        {
            message = new Modal('Eingabe wird verarbeitet.');
        }
        Load.post('shop/shipping', {
            f: 'delivery',
            action: action,
            delivery: this.delivery,
            pickup: this.pickup
        }).then(r => {
            if(noMessage !== true)
            {
                message.remove();
            }
            switch(action)
            {
                case 'build':
                    document.getElementById('w--main').innerHTML = r['html'];
                    document.title = r['pageTitle'].replace('&amp;', '&');
                    document.documentElement.scrollTo(0, 0);
                    History.push_url(Basic.base + 'shop/shipping', r['pageTitle']);
                    this.get_limits();
                    this.update_customAddressForm();
                    Basic.do_afterLoad();
                    break;

                case 'edit-custom-address':
                    r['statusDelivery'] = false;
                    const myDiv = document.getElementById('w--address-enter');
                    if(myDiv)
                    {
                        myDiv.innerHTML = r['html'];
                        Basic.do_afterLoad();
                    }
                    break;

                case 'update-address':
                case 'update-delivery':
                    const detailsDiv = document.getElementById('w--delivery-details');
                    if(detailsDiv)
                    {
                        detailsDiv.innerHTML = r['html'];
                    }
                    break;

                case 'update-pickup':
                case 'update-delivery-date':
                    this.update_deliveryStatus(r['date_error']);
                    break;
            }
            this.set_submitButton(r['statusDelivery']);
        }).catch(error => {
            if(noMessage !== true)
            {
                message.remove();
            }
            new Modal('Ihre Eingabe konnte nicht verarbeitet werden.',true);
            console.error(error);
        });
    }

    set_submitButton(status)
    {
        if(status !== undefined)
        {
            const submitButton = document.body.querySelector('.w__shop--buttons .w__button--submit');
            if(submitButton)
            {
                (status === true &&
                 !(this.delivery.target === 'enter' &&
                   document.getElementById('w--address-enter') &&
                   document.getElementById('w--address-enter').querySelector('.w__form')))
                    ? submitButton.classList.remove('inactive')
                    : submitButton.classList.add('inactive')
            }
        }
    }

    get_limits()
    {
        if(document.getElementById('w--shop-delivery'))
        {
            this.limits = JSON.parse(document.getElementById('w--shop-delivery').dataset.limits);
        }
    }

    toggle_address(el)
    {
        let activeDiv = document.body.querySelector('.w__address--description.active');
        if(activeDiv)
        {
            activeDiv.classList.remove('active');
        }

        activeDiv = document.getElementById('w--address-' + el.value);
        if(activeDiv)
        {
            activeDiv.classList.add('active');
        }
        this.delivery.target = el.value;
        this.update_session('update-address');
    }

    toggle_deliveryType(el)
    {
        this.delivery.type = el.value;
        this.update_session('update-delivery');
    }

    get_customAddressFields()
    {
        const myForm = document.getElementById('w--address-enter');
        return myForm ? myForm.querySelectorAll('.w__input') : null;
    }

    update_customAddress(fields, address)
    {
        this.delivery.customAddress = {};

        for(const [key, value] of Object.entries(fields))
        {
            this.delivery.customAddress[key] = value;
        }

        const myDiv = document.getElementById('w--address-enter');
        if(myDiv)
        {
            myDiv.innerHTML = address;
        }

        this.update_session('update-delivery');
    }

    update_customAddressForm()
    {
        if(this.delivery.customAddress)
        {
            const fields = this.get_customAddressFields();
            if(fields)
            {
                fields.forEach(el => {
                    el.value = this.delivery.customAddress[el.name] ??= '';
                });
            }
        }
    }

    update_session(action, noMessage)
    {
        localStorage.setItem('delivery', JSON.stringify(this.delivery));
        sessionStorage.setItem('pickup', JSON.stringify(this.pickup));

        if(action)
        {
            this.process(action, noMessage);
        }
    }

    update_deliveryStatus(statusText)
    {
        if(statusText !== undefined)
        {
            document.getElementById('w--delivery-input-status').textContent = statusText ? 'Ungültiges Datum: ' + statusText : '';
        }
    }

    validate_date(myDate, f)
    {
        let statusText = '';

        const testDate = new Date(myDate.value),
              day = testDate.getDay(); // Sunday = 0

        if(myDate.value < myDate.min)
        {
            // too early
            statusText = 'Sie haben ein zu frühes Datum gewählt.'
        }
        else if(f === 'delivery')
        {
            if(this.limits.closedDelivery.daysNo.includes(day))
            {
                // Monday or Sunday
                statusText = this.limits.closedDelivery.text;
            }
        }
        else if(f === 'pickup')
        {
            if(this.limits.closedPickup.daysNo.includes(day))
            {
                // Monday
                statusText = this.limits.closedPickup.text;
            }
        }

        return statusText;
    }

    validate_deliveryDate(send)
    {
        const detailsDiv = document.getElementById('w--delivery-details');
        if(detailsDiv)
        {
            let status = false,
                statusText = '';
            const myDate = detailsDiv.querySelector('.w__input[name="date"]');
            if(myDate.value)
            {
                statusText = this.validate_date(myDate, 'delivery');
                if(!statusText)
                {
                    status = true;
                }
            }

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.update_deliveryStatus(statusText);
                this.set_submitButton(status);
                this.pickup.date = myDate.value;

                /*
                if(status === true)
                {
                    this.pickup.date = myDate.value;
                }
                else
                {
                    delete(this.pickup.date);
                    send = false;
                }
                */

                if(send === true)
                {
                    this.update_session('update-delivery-date',true);
                }
            },250);
        }
    }

    validate_pickupDateTime(send)
    {
        const detailsDiv = document.getElementById('w--delivery-details');
        if(detailsDiv)
        {
            let status = false,
                statusText = '';
            const myDate = detailsDiv.querySelector('.w__input[name="date"]'),
                  myTime = detailsDiv.querySelector('.w__input[name="time"]');
            if(myDate.value)
            {
                statusText = this.validate_date(myDate, 'pickup');
                if(!statusText)
                {
                    status = true;

                    const testDate = new Date(myDate.value),
                          day = testDate.getDay(); // Sunday = 0

                    if(myTime.value)
                    {
                        if(day === 0 && (myTime.value < this.limits.openSun.from || myTime.value > this.limits.openSun.to))
                        {
                            // Sunday and wrong time
                            status = false;
                            statusText = this.limits.openSun.text;
                        }
                        else if(day === 6 && (myTime.value < this.limits.openSat.from || myTime.value > this.limits.openSat.to))
                        {
                            // Saturday and wrong time
                            status = false;
                            statusText = this.limits.openSat.text;
                        }
                        else if(myTime.value < this.limits.open.from || myTime.value > this.limits.open.to)
                        {
                            // wrong time
                            status = false;
                            statusText = this.limits.open.text;
                        }
                    }
                    else
                    {
                        // missing time
                        status = false;
                    }
                }
            }

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.update_deliveryStatus(statusText);
                this.set_submitButton(status);

                if(status === true)
                {
                    this.pickup.date = myDate.value;
                    this.pickup.time = myTime.value;
                }
                else
                {
                    delete(this.pickup.date);
                    delete(this.pickup.time);
                }

                if(send === true)
                {
                    this.update_session('update-pickup',true);
                }
            },250);
        }
    }
}